// extracted by mini-css-extract-plugin
export default {"container":"ProductBlock_container__gOuIF","fade":"ProductBlock_fade__hXErL"};